export default __webpack_public_path__ + "static/media/bd-background-large.d1b8ca6a.jpg";